export const ERROR_MESSAGE_SERVICE_NOT_AVAILABLE =
  'The requested requisite is not available. Please try again later.';
